/*
 * 独立组件：柴发并机启动带载测试（MwDgParallel）
 * 对应原 Maintian_sub_processes_DGT_month 表单，不与头部 / 尾部组合，整单只有本组件
 * 流程变量沿用原表单：
 *   A_M（自动 / 手动）、device_list（[{device_Name, DeviceNumber, FuncRoomName, device_uid, sub_button}]，sub_button 为准备确认开关）、
 *   get_data_button（获取数据开关）、get_status（后端取数循环 "1" 运行中 / "0" 结束）、
 *   auto_form（按设备的自动取数记录 [{device_uid, form1, form2, ...}]，由后端循环写入，组件只读）、card1（手动模式人工记录）、
 *   txt_n_150 / txt_m_150 / txt_s_150 为检查项文案（随表单提交）
 * 操作顺序：确认参与并机的设备 -> 打开【获取数据】（后端按设备循环取数）-> 测试完成后关闭 -> 提交
 * 依赖：core.js ui.js biz.js sync.js points.js
 */
export default function installParallelDg(MW) {
  var h = MW.h, ui = MW.ui, biz = MW.biz, util = MW.util, store = MW.store, api = MW.api;
  var v = biz.v;
  var PT = MW.points;
  var sync = MW.sync;

  var TXT = {
    n: "并机启动带假负载/空载测试",
    m: "并机柴发带载/空载数据记录",
    s: "发动机：转速(RPM)；机油压力(KPA)；冷却水温(℃) 发电机：电压（V）；频率(HZ)；电流(A)；有功功率(KW)；视在功率(KVA)；功率因数(PF)",
  };
  var busy = {};

  /* ---------- 取值与条件 ---------- */
  function lock() { return biz.isClosed(); }
  function empty(x) { return util.isEmpty(x); }
  function autoMode() { return v("A_M") !== "手动"; }
  function arr(k) { return Array.isArray(v(k)) ? v(k) : []; }
  function devices() { return arr("device_list"); }
  function cards() { return arr("card1"); }
  function devName(d) { return d.device_Name || d.device_name || d.DeviceNumber || d.device_number || "柴油发电机组"; }
  function devNo(d) { return d.DeviceNumber || d.device_number || ""; }
  function selected() { return devices().filter(function (d) { return d.sub_button === true; }); }
  function getting() { return v("get_data_button") === true; }
  function running() { return String(v("get_status")) === "1"; }
  /** 设备对应的自动取数记录（按 device_uid 匹配，缺失时按设备编号） */
  function rowsOfDev(d) {
    var list = arr("auto_form");
    var e = list.filter(function (x) { return x && d.device_uid && x.device_uid === d.device_uid; })[0] ||
      list.filter(function (x) { return x && devNo(d) && (x.DeviceNumber || x.device_number) === devNo(d); })[0];
    return PT.rowsOf(e);
  }
  function rowCount() {
    return devices().reduce(function (n, d) { return n + rowsOfDev(d).length; }, 0);
  }
  function hasData() {
    return selected().some(function (d) { return rowsOfDev(d).length > 0; });
  }
  /** 设备选择可编辑：未开始取数且组件可操作 */
  function devEditable() { return !lock() && !getting() && !busy.get; }

  /* ---------- 保存 ---------- */
  function setVal(k, val, typing) {
    store.set(k, val, typing ? { silent: true } : undefined);
    if (typing) sync.typing(k);
    else sync.save(k);
  }
  /** 设备准备确认：按项保存 device_list.N.sub_button，避免覆盖后端回填的 device_uid */
  function setDev(idxs, val) {
    var list = util.clone(devices());
    idxs.forEach(function (i) { if (list[i]) list[i].sub_button = val; });
    store.set("device_list", list);
    idxs.forEach(function (i) { sync.save("device_list." + i + ".sub_button"); });
  }

  function onGetData(val) {
    var prev = v("get_data_button");
    if (val) {
      if (!selected().length) return ui.toast("请先在上方确认至少一台参与并机测试的设备", "warn");
      if (MW.net.offline) return MW.offline.needNet("获取测点数据");
    }
    var uids = selected().map(function (d) { return d.device_uid; }).filter(Boolean);
    busy.get = 1;
    store.set("get_data_button", val);
    sync.save("get_data_button");
    api.call(val ? "get_zhiwei_data" : "end_get_form_data", val ? { device_uid: uids } : {})
      .then(function (resp) {
        var r = resp && resp.data ? resp.data.result : null;
        if (r && r.status === "error") {
          // 后端取数有全局节流：未真正开始取数时恢复开关，便于稍后重试
          store.set("get_data_button", prev === undefined ? null : prev);
          sync.save("get_data_button");
          ui.toast(r.message || "请求过于频繁，请稍后再试", "warn");
        } else {
          ui.toast(val ? "已开始获取 " + uids.length + " 台设备的测点数据，约每分钟刷新一次" : "已结束获取数据", val ? "info" : "ok");
        }
      })
      .catch(function (e) { ui.toast((val ? "获取数据" : "结束获取数据") + "失败：" + (util.errMsg(e) || "服务异常"), "danger"); })
      .then(function () { delete busy.get; store.touch("get_data_button"); });
  }

  /* ---------- 校验 ---------- */
  function missing() {
    var out = [];
    if (!autoMode()) return PT.cardMissing(cards(), "pl", devices().map(devName));
    if (!selected().length) out.push({ key: "pl.dev", msg: "请确认至少一台参与并机测试的设备" });
    if (getting()) out.push({ key: "pl.get", msg: "请在测试完成后关闭【获取数据】" });
    else if (v("get_data_button") !== false) out.push({ key: "pl.get", msg: "请打开【获取数据】记录并机带载数据，完成后关闭" });
    else if (!hasData()) out.push({ key: "pl.data", msg: "尚未获取到测点数据，请重新打开【获取数据】或改为人工记录" });
    return out;
  }

  /* ---------- 渲染 ---------- */
  function hero() {
    return biz.hero({
      icon: "ri-flashlight-fill",
      crumbs: [v("maintenance_type") || "维护", v("maintenance_cycle"), "并机测试"],
      title: v("ProcessTitle") || v("process_title") || ((v("mozu_name") || "") + "-柴发启机测试维护工单"),
      chips: [v("maintenance_process_type"), v("professional")],
    });
  }

  function basicInfo() {
    return biz.infoPanel([
      ["主单号", "main_ticket_id", "ri-file-list-3-line"], ["园区", "campus_name", "ri-building-2-line"], ["模组", "mozu_name", "ri-layout-grid-line"],
      ["设备类型", "devicetypes_name", "ri-cpu-line"], ["维护类型", "maintenance_type", "ri-shield-check-line"], ["维护周期", "maintenance_cycle", "ri-repeat-line"],
      ["维护单位", "maintainer", "ri-team-line"], ["计划开始日期", "plan_start_date", "ri-calendar-event-line"], ["计划结束日期", "plan_end_date", "ri-calendar-check-line"],
    ]);
  }

  /** 检查项说明 + 数据记录方式 */
  function intro() {
    var auto = autoMode();
    var lines = TXT.s.split(/\s+(?=发电机：)/);
    return h("div", { class: "mw-pl-intro" },
      h("div", { class: "mw-pl-intro__main" },
        h("span", { class: "mw-sub__sn" }, h("i", { class: "ri-flashlight-line" })),
        h("div", null, h("h4", null, TXT.m), h("p", null, "多台柴发机组并机运行，系统按设备记录带载 / 空载测点数据"))),
      h("div", { class: "mw-dg-std" }, h("b", null, h("i", { class: "ri-file-list-3-line" }), "记录项"), lines.map(function (l) { return h("p", null, l); })),
      h("div", { class: "mw-dg-sec" }, h("i", { class: "ri-database-2-line" }), h("b", null, "数据记录方式"),
        ui.tag(auto ? "自动" : "手动", auto ? "info" : "muted", auto ? "ri-robot-2-line" : "ri-edit-2-line"),
        h("small", null, auto ? "由系统从动环测点自动获取" : "测点数据不可用，请人工填写")));
  }

  /** 设备准备确认：卡片式勾选，开始取数后锁定 */
  function devPick(err) {
    var list = devices(), ed = devEditable();
    var nSel = selected().length, all = list.length > 0 && nSel === list.length;
    var tip = lock() ? null : getting() ? "正在获取数据，如需调整设备请先关闭【获取数据】" : null;
    return h("div", { class: ["mw-pl-devs", err("dev") && "has-error"], dataset: { key: "pl.dev" } },
      h("div", { class: "mw-pl-devs__head" },
        h("b", null, h("i", { class: "mw-req" }, "*"), "设备准备确认"),
        ui.tag("已确认 " + nSel + " / " + list.length + " 台", nSel ? "ok" : "muted", "ri-checkbox-multiple-line"),
        list.length > 1 && ui.btn(all ? "取消全选" : "全选", { type: "text", size: "sm", icon: all ? "ri-checkbox-indeterminate-line" : "ri-checkbox-multiple-line", disabled: !ed,
          onClick: function () { setDev(list.map(function (d, i) { return i; }), !all); } })),
      tip && h("div", { class: "mw-alert mw-alert--info" }, h("i", { class: "ri-lock-2-line" }), h("div", null, tip)),
      !list.length && h("div", { class: "mw-empty" }, h("i", { class: "ri-inbox-2-line" }), "工单未关联柴发设备"),
      list.length > 0 && h("div", { class: "mw-pl-devs__grid" }, list.map(function (d, i) {
        var on = d.sub_button === true;
        return h("div", { class: ["mw-pl-dev", on && "is-on", !ed && "is-disabled"], style: { animationDelay: Math.min(i, 8) * 30 + "ms" },
          onClick: function (e) { if (ed && !e.target.closest(".mw-switch")) setDev([i], !on); } },
          h("div", { class: "mw-pl-dev__icon" }, h("i", { class: on ? "ri-checkbox-circle-fill" : "ri-settings-5-line" })),
          h("div", { class: "mw-pl-dev__main" },
            h("b", null, devName(d)),
            h("small", { class: "is-mono" }, devNo(d) || "—"),
            d.FuncRoomName && h("small", null, h("i", { class: "ri-map-pin-2-line" }), d.FuncRoomName)),
          ui.switch({ value: on, disabled: !ed, onChange: function (val) { setDev([i], val); } }));
      })),
      err("dev") && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), err("dev")));
  }

  function getSwitch(err) {
    var gb = getting(), off = v("get_data_button") === false;
    var dis = lock() || (!gb && !selected().length);
    return biz.switchRow({
      title: "获取数据", required: true, key: "pl.get", icon: "ri-download-cloud-2-line",
      time: gb ? (running() ? "正在获取 " + selected().length + " 台设备的测点数据…" : "已请求获取，等待数据返回") : off ? "已结束获取数据" : "并机带载运行后打开开关获取测点数据，测试完成后关闭",
      value: gb, disabled: dis, loading: !!busy.get, onChange: onGetData, error: err("get"),
      tip: !lock() && !gb && !selected().length ? "请先确认参与并机测试的设备" : null, cls: "mw-pl-sw",
    });
  }

  /** 按设备展示自动取数结果 */
  function devData(err, list) {
    if (!list.length) return null;
    return h("div", { class: ["mw-pl-data", err("data") && "has-error"], dataset: { key: "pl.data" } },
      list.map(function (d, i) {
        var rows = rowsOfDev(d);
        var on = d.sub_button === true;
        var tag = !on ? ui.tag("未参与", "muted", "ri-forbid-line") :
          getting() && running() ? ui.tag("取数中", "info", "ri-loader-4-line mw-spin") :
            rows.length ? ui.tag(rows.length + " 条", "ok", "ri-check-line") : ui.tag(getting() ? "等待数据" : "无数据", getting() ? "info" : "muted", "ri-time-line");
        return h("article", { class: ["mw-pl-card", rows.length && "is-ok"], style: { animationDelay: Math.min(i, 8) * 40 + "ms" } },
          h("div", { class: "mw-pl-card__head" },
            h("span", { class: "mw-sub__sn" }, "#" + (i + 1)),
            h("div", { class: "mw-pl-card__title" }, h("b", null, devName(d)), h("small", { class: "is-mono" }, devNo(d))),
            tag),
          PT.view(rows, "pl-" + (d.device_uid || devNo(d) || i), getting() ? "等待测点数据返回，约每分钟刷新一次" : "暂无数据，打开【获取数据】后自动刷新"));
      }),
      err("data") && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), err("data")));
  }

  function autoBlock(err) {
    var list = devices().filter(function (d) { return d.sub_button === true || rowsOfDev(d).length; });
    return h("div", { class: "mw-pl-body" }, devPick(err), getSwitch(err),
      list.length > 0 && h("div", { class: "mw-dg-sec mw-pl-sec" }, h("i", { class: "ri-line-chart-line" }), h("b", null, "测点数据"),
        h("small", null, "按设备展示最新数据与历史记录（每台最多保留 30 条）")),
      devData(err, list));
  }

  function manualBlock(err) {
    var auto = devices().filter(function (d) { return rowsOfDev(d).length; });
    return h("div", { class: "mw-pl-body" },
      h("div", { class: "mw-alert mw-alert--warn" }, h("i", { class: "ri-error-warning-line" }), h("div", null, "动环测点数据不可用，请按设备人工记录并机带载数据")),
      PT.cards({
        rows: cards(), prefix: "pl", name: "pl", disabled: lock(), err: err,
        devices: devices().map(devName), defaultName: v("devicetypes_name"),
        set: function (list, typing) { setVal("card1", list, typing); },
      }),
      auto.length > 0 && h("div", { class: "mw-dg-sec mw-pl-sec" }, h("i", { class: "ri-history-line" }), h("b", null, "已自动获取的数据"), h("small", null, "切换为人工记录前系统已获取的测点数据（只读）")),
      auto.length > 0 && devData(function () { return null; }, auto));
  }

  /* ---------- 适配器：同步 / 提交据此了解本组件 ---------- */
  var KEYS = ["A_M", "device_list", "get_data_button", "get_status", "auto_form", "card1", "ProcessTitle", "devicetypes_name", "maintainer",
    "maintenance_type", "maintenance_process_type", "professional", "txt_n_150", "txt_m_150", "txt_s_150"];
  var LABELS = { A_M: "数据记录方式", device_list: "设备准备确认", get_data_button: "获取数据", get_status: "获取数据", auto_form: "测点数据", card1: "人工记录" };
  var ADAPTER = {
    name: "parallel_dg",
    started: function () { return autoMode() ? getting() || v("get_data_button") === false : cards().length > 0; },
    startTime: function () { return ""; },
    allDone: function () { return !missing().length; },
    abnormalCount: function () { return 0; },
    abnormalList: function () { return []; },
    stepText: function () { return autoMode() ? selected().length + " 台设备" : cards().length + " 条记录"; },
    keys: function () { return KEYS; },
    labels: LABELS,
  };

  /** 检查项文案随表单提交；未设置记录方式时默认自动取数（与原表单一致） */
  function seed() {
    var o = {};
    if (v("txt_n_150") !== TXT.n) o.txt_n_150 = TXT.n;
    if (v("txt_m_150") !== TXT.m) o.txt_m_150 = TXT.m;
    if (v("txt_s_150") !== TXT.s) o.txt_s_150 = TXT.s;
    if (empty(v("A_M"))) o.A_M = "自动";
    if (Object.keys(o).length) store.patch(o, { silent: true });
  }

  biz.part({
    name: "parallel_dg",
    title: "并机测试",
    middle: ADAPTER,
    solo: true,
    render: function (ctx) {
      var err = function (k) { return ctx.err("pl." + k); };
      return h("div", { class: ["mw-header", "mw-pl"] },
        hero(),
        biz.closedBanner(),
        basicInfo(),
        ui.panel({ title: TXT.n, icon: "ri-flashlight-line", id: "mw-pl-test", sub: autoMode() ? "自动取数" : "人工记录",
          badge: hasData() || cards().length ? ui.tag(autoMode() ? rowCount() + " 条数据" : cards().length + " 条记录", "ok", "ri-check-line") : null },
          intro(),
          autoMode() ? autoBlock(err) : manualBlock(err)));
    },
    errors: function () { return missing(); },
    mounted: function () { seed(); },
  });
}
